import { createRouter, createWebHistory } from 'vue-router'
import Home from './components/HomePage.vue'
//import Kefu from './components/Kefu.vue'
//import Wode from './components/Wode.vue'
//import Login from './components/Login.vue'
import Detail from './components/GoodsDetail.vue'

const routes = [
    {
        path: '/',
        name: 'Home', 
        component: Home,
        meta: {
            keepAlive: true,
            title: 'PUBG选号网'
        }
    },
     { 
      path: '/detail', 
      name: 'Detail',
      component: Detail,
      meta: {
        title: '账号详情'
      }
     }
]

const router = createRouter({
  //history: createWebHistory(),
  history: createWebHistory('/'),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 返回页面时恢复滚动位置
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

export default router